module.exports = __webpack_public_path__ + "static/media/help-header-v2.3078fcf1.png";